/*
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2020, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */

import {h} from 'hyperapp';
import {createField} from '../element';

/**
 * A text field
 * @param {Object} props Properties
 * @param {string} [props.value] Value
 * @param {BoxProperties} [props.box] Box Properties
 * @param {h[]} children Children
 */
export const SelectField = (props = {}, children = []) => {

  const getChoices = choices => choices instanceof Array
    ? choices.map(value => typeof value === 'object' ? value : {value, label: value})
    : Object.keys(props.choices || {})
      .map(value => ({value, label: props.choices[value]}));

  const choices = getChoices(props.choices)
    .map(({value, label}) => {
      return h('option', {
        value,
        selected: props.value === value
      }, label);
    });

  const getValue = ev => [ev.target.value, ev.target.textContent];
  const createSelect = fieldProps => h('div', {}, h('select', fieldProps, [
    ...choices,
    ...children
  ]));

  return createField('select-field', props, {
    selectedIndex: undefined
  }, createSelect, getValue);
};
